<template lang="pug">
#drawer-menu-ferramentas
    el-drawer(
        :title='title',
        direction='rtl',
        :class='menuMaior ? "drawer-menu-ferramentas" : "drawer-menu-ferramentas menor"',
        :visible.sync='show',
        :before-close='closeDrawerMenuFerramentas',
        :wrapperClosable='false',
        :modal='false',
        :lock-scroll='true',
        :append-to-body='false',
        :close-on-press-escape='true',
        :size='menuMaior ? 360 : 247'
    )
        template(slot='title', slot-scope='scope')
            div(:class='menuMaior ? "titulo-drawer" : "titulo-drawer-menor"')
                i.mdi.mdi-wrench-outline.mdi-flip-h
                |
                | {{ title }}

        .card-container
            el-menu(
                :default-active='defaultActive',
                :class='menuMaior ? "" : "menu-menor"',
                :collapse='false',
                @select='processarEscolhaMenu'
            )
                div(v-for='item in itemsMenuFerramentas', :key='item.index')
                    el-menu-item(
                        v-if='!item.hasSubOptions && item.hasPermission',
                        :index='item.index',
                        :disabled='item.disabled'
                    )
                        i(:class='item.icon')
                        span(slot='title') {{ item.name }}
                            i(
                                v-if='item.hasSubOptions',
                                :class='item.hasSubOptions ? "mdi mdi-chevron-right ml-1" : "mdi mdi-chevron-right ml-1"'
                            )
                    el-submenu(
                        :index='item.index',
                        v-if='item.hasSubOptions && item.index === "1" && item.hasPermission'
                    )
                        template(slot='title')
                            i(:class='item.icon')
                            span {{ item.name }}
                        el-menu-item-group
                            span
                            ModalAnotacao(
                                :mapa='mapa',
                                @closeDrawerMenuFerramentas='closeDrawerMenuFerramentas',
                                @adicionarAnotacao='adicionarAnotacao',
                                :dadosDaAnotacaoEdicao='dadosDaAnotacaoEdicao'
                            )
                    el-submenu(
                        :index='item.index',
                        v-if='item.hasSubOptions && item.index === "3" && item.hasPermission'
                    )
                        template(slot='title')
                            i(:class='item.icon')
                            span {{ item.name }}
                        el-menu-item-group
                            span
                            UploadFile(:mapa='mapa')
                    el-submenu(
                        :index='item.index',
                        v-if='item.hasSubOptions && item.index === "4" && item.hasPermission'
                    )
                        template(slot='title')
                            i(:class='item.icon')
                            span {{ item.name }}
                        el-menu-item-group
                            span
                            ModalCoordenadas(
                                @dadosFormCoodernadas='dadosFormCoodernadas'
                            )
                    el-submenu(
                        :index='item.index',
                        v-if='item.hasSubOptions && item.index === "5" && item.hasPermission'
                    )
                        template(slot='title')
                            i(:class='item.icon')
                            span {{ item.name }}
                        el-menu-item-group
                            span
                                UploadPlanilha(
                                    @showPopupAcoes='showPopupAcoes',
                                    :mapa='mapa'
                                )
</template>

<script>
import ModalCoordenadas from '@/components/mapa/popup/ModalCoordenadas.vue';
import UploadFile from '@/components/mapa/uploadFile/UploadFile.vue';
import UploadPlanilha from '@/components/mapa/uploadFile/UploadPlanilha.vue';
import ModalAnotacao from '@/components/mapa/popup/ModalAnotacao.vue';
export default {
    name: 'DrawerMenuFerramentas',

    components: {
        ModalAnotacao,
        ModalCoordenadas,
        UploadFile,
        UploadPlanilha
    },

    props: {
        mapa: {
            required: true
        },
        show: {
            type: Boolean,
            required: false,
            default: false
        },
        menuMaior: {
            type: Boolean,
            required: false,
            default: false
        },
        mapConfigControls: {
            type: Object,
            required: true,
            default: () => {
                return {};
            }
        },
        limparMenuFerramentasAtivo: {
            type: Boolean,
            required: false,
            default: false
        },
        dadosDaAnotacaoEdicao: {
            type: Object
        }
    },

    data() {
        return {
            defaultActive: '',
            itemsMenuFerramentas: []
        };
    },

    computed: {
        title() {
            return this.$t('mensagens.menuMapa.ferramentas');
        }
    },

    watch: {
        limparMenuFerramentasAtivo(newValue) {
            if (newValue) {
                this.defaultActive = '';
                setTimeout(() => {
                    this.$emit('resetarLimparMenuFerramentasAtivo');
                }, 100);
            }
        },
        '$i18n.locale': function (newLocale) {
            this.updateMenuItems();
        }
    },

    created() {
        this.updateMenuItems();
    },

    methods: {
        updateMenuItems() {
            this.itemsMenuFerramentas = [
                {
                    index: '0',
                    icon: 'mdi mdi-pin-outline',
                    name: this.$t('mensagens.menuMapa.fixarZoom'),
                    hasSubOptions: false,
                    hasPermission: false
                },
                {
                    index: '1',
                    icon: 'mdi mdi-comment-text-outline',
                    name: this.$t('mensagens.menuMapa.anotacao'),
                    hasSubOptions: true,
                    hasPermission: false
                },
                {
                    index: '2',
                    icon: 'mdi mdi-map-marker-outline',
                    name: this.$t('mensagens.menuMapa.marcarPonto'),
                    hasSubOptions: false,
                    hasPermission: false
                },
                {
                    index: '3',
                    icon: 'mdi mdi-cloud-upload-outline',
                    name: this.$t('mensagens.menuMapa.uploadArquivoVetorial'),
                    hasSubOptions: true,
                    hasPermission: false
                },
                {
                    index: '4',
                    icon: 'mdi mdi-map-search-outline',
                    name: this.$t(
                        'mensagens.menuMapa.buscarAreaPorCoordenadas'
                    ),
                    hasSubOptions: true,
                    hasPermission: false
                },
                {
                    index: '5',
                    icon: 'mdi mdi-shape-polygon-plus',
                    name: this.$t('mensagens.menuMapa.gerarPoligono'),
                    hasSubOptions: true,
                    hasPermission: false
                }
            ];

            this.handlePermissions();
        },

        closeDrawerMenuFerramentas() {
            this.$emit('closeDrawerMenuFerramentas');
        },

        processarEscolhaMenu(opcao) {
            this.defaultActive = opcao;
            if (opcao === '0') {
                this.$emit('fixaZoom');
                if (this.defaultActive === 0) {
                    let isActive = document.querySelector(
                        '#drawer-menu-ferramentas .is-active'
                    );
                    if (isActive) {
                        isActive.classList.remove('is-active');
                    }
                }
            } else if (opcao === '2') {
                this.processCreateMarkerOnClick();
            }
        },

        handlePermissions() {
            if (Object.keys(this.mapConfigControls).length > 0) {
                if (
                    this.mapConfigControls.zoomControl === undefined ||
                    this.mapConfigControls.zoomControl
                ) {
                    this.itemsMenuFerramentas[0].hasPermission = true;
                }
                if (
                    this.mapConfigControls.botaoAnotacoes === undefined ||
                    this.mapConfigControls.botaoAnotacoes
                ) {
                    this.itemsMenuFerramentas[1].hasPermission = true;
                }
                if (
                    this.mapConfigControls.marcarPontoControl === undefined ||
                    this.mapConfigControls.marcarPontoControl
                ) {
                    this.itemsMenuFerramentas[2].hasPermission = true;
                }

                if (
                    this.mapConfigControls.uploadFileControl === undefined ||
                    this.mapConfigControls.uploadFileControl
                ) {
                    this.itemsMenuFerramentas[3].hasPermission = true;
                }

                if (
                    this.mapConfigControls.buscarAreaPorCoordenadasControl ===
                        undefined ||
                    this.mapConfigControls.buscarAreaPorCoordenadasControl
                ) {
                    this.itemsMenuFerramentas[4].hasPermission = true;
                }

                if (
                    this.mapConfigControls.gerarPoligono === undefined ||
                    this.mapConfigControls.gerarPoligono
                ) {
                    this.itemsMenuFerramentas[5].hasPermission = true;
                }
            }
        },

        dadosFormCoodernadas(dados) {
            this.$emit('dadosFormCoodernadas', dados);
        },
        adicionarAnotacao(dados) {
            setTimeout(() => {
                this.$emit('adicionarAnotacao', dados);
                this.closeDrawerMenuFerramentas();
            }, 100);
        },
        processCreateMarkerOnClick() {
            setTimeout(() => {
                this.$emit('createMarkerOnClick');
                this.$emit('closeDrawerMenuFerramentas');
            }, 100);
        },
        showPopupAcoes(layer) {
            this.$emit('showPopupAcoes', layer);
        }
    }
};
</script>

<style lang="scss">
#drawer-menu-ferramentas {
    font-family: 'Roboto', 'sans serif';

    .el-drawer.rtl {
        border-radius: 0 3px 3px 0;
    }

    .drawer-menu-ferramentas {
        z-index: 500 !important;
        position: absolute;

        #el-drawer__title > button > i {
            &::before {
                color: #3b3b3b;
                font-weight: 600;
                font-size: 16px;
            }
        }
    }

    .drawer-menu-ferramentas.menor {
        #el-drawer__title > button > i {
            &::before {
                color: #3b3b3b;
                font-weight: 600;
                font-size: 14px;
            }
        }
    }

    .el-drawer__body {
        @include scroll-bar();
    }

    .card-container {
        height: 100%;
        background-color: var(--white);
        padding: 5px 8px;
        overflow-y: auto;
        overflow-x: hidden;

        .el-menu {
            width: 100%;
            border-right: none;
            display: flex;
            flex-direction: column;

            .el-menu-item,
            .el-submenu__title {
                padding: 0;
                border-radius: 5px;
                display: flex;
                justify-content: center;
                align-items: center;
                padding-left: 8px !important;
                height: 42px;
                line-height: 42px;

                i {
                    color: #3b3b3b;
                    transition: all 0.3s ease-in-out;
                }

                i.mdi {
                    margin-right: 11px;
                    text-align: center;
                    font-size: 22px;
                    vertical-align: middle;
                }

                i.el-icon-arrow-down {
                    transform: rotate(270deg);
                    color: #3b3b3b;
                    font-size: 16px;
                    font-weight: 600;
                }

                span {
                    width: 100%;
                    color: #3b3b3b;
                    font-weight: 400;
                    font-size: 14px;
                    transition: color 0.3s ease-in-out;
                    display: flex;
                    justify-content: space-between;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    overflow: hidden;
                    line-height: 16px;
                    letter-spacing: 0em;
                    text-align: left;
                }

                .el-tooltip {
                    padding: 0px 18px;
                }
            }

            .el-submenu__icon-arrow {
                right: 10px;
            }

            .el-submenu.is-opened > .el-submenu__title .el-submenu__icon-arrow {
                transform: rotate(360deg) !important;
            }

            .el-menu-item.is-active {
                color: var(--primary);
                background-color: #b5dc6966;

                i {
                    color: var(--primary);
                }

                span {
                    color: var(--primary);
                    font-weight: 500;
                }
            }
        }

        .el-menu.menu-menor {
            width: 100%;
            border-right: none;
            display: flex;
            flex-direction: column;

            .el-menu-item,
            .el-submenu__title {
                padding: 0;
                border-radius: 5px;
                display: flex;
                justify-content: center;
                align-items: center;
                padding-left: 8px !important;
                height: 42px;
                line-height: 42px;

                i {
                    color: #3b3b3b;
                    transition: all 0.3s ease-in-out;
                }

                i.mdi {
                    margin-right: 11px;
                    text-align: center;
                    font-size: 18px;
                    vertical-align: middle;
                }

                i.el-icon-arrow-down {
                    transform: rotate(270deg);
                    color: #3b3b3b;
                    font-size: 14px;
                    font-weight: 600;
                }

                span {
                    width: 100%;
                    color: #3b3b3b;
                    font-weight: 400;
                    font-size: 12px;
                    transition: color 0.3s ease-in-out;
                    display: flex;
                    justify-content: space-between;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    overflow: hidden;
                    line-height: 16px;
                    letter-spacing: 0em;
                    text-align: left;
                }

                .el-tooltip {
                    padding: 0px 18px;
                }
            }

            .el-submenu__icon-arrow {
                right: 10px;
            }

            .el-submenu.is-opened > .el-submenu__title .el-submenu__icon-arrow {
                transform: rotate(360deg) !important;
            }

            .el-menu-item.is-active {
                color: var(--primary);
                background-color: #b5dc6966;

                i {
                    color: var(--primary);
                }

                span {
                    color: var(--primary);
                    font-weight: 500;
                }
            }
        }

        .el-menu:not(.el-menu--collapse) {
            width: 100%;

            &::before {
                content: '';
                position: absolute;
                width: 32px;
                height: 15px;
                top: -5px;
                right: -32px;
                border-radius: 32px 10px 40px 10px;
                -webkit-box-shadow: -20px -20px 0 var(--primary);
                box-shadow: -14px -3px 0 var(--primary);
                z-index: -1;
            }
        }
    }

    .titulo-drawer {
        font-size: 17px;
        font-weight: 500;
        color: var(--primary);
    }

    .titulo-drawer-menor {
        font-size: 15px;
        font-weight: 500;
        color: var(--primary);
    }

    .text-align-right {
        text-align: right;
    }

    .float-box .float-box-title h2 {
        padding-top: 19px;
        font-size: 16px;
        padding-right: 16px;
        padding-left: 22px;
        width: 100%;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
    }

    .pull-left {
        float: left;
    }

    .el-drawer__header {
        background-color: #e9e9e9;
        padding: 15px !important;
        margin-bottom: 0px;
    }

    .float-box-title {
        width: 100%;
        background-color: #ecf0f1;
    }

    .float-box .float-box-collapse-icon {
        position: absolute;
        right: 15px;
        top: 17px;
        z-index: 10001;
        font-size: 16px;
    }

    .action-icon {
        cursor: pointer;
        color: #777;
    }
}
</style>
